<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				{{ showBlocked ? 'Заблокированные пользователи' : 'Пользователи' }}
				<v-spacer></v-spacer>

				<v-menu left offset-x slide-y class="">
					<template v-slot:activator="{ on }" class="">
						<v-btn v-on="on" icon class="mt-6">
							<v-icon>more_vert</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template>
							<v-list-item @click="newUser">
								<v-list-item-action>
					              	<v-icon>add_circle</v-icon>
					            </v-list-item-action>
								<v-list-item-title>
									Добавить пользователя
								</v-list-item-title>
							</v-list-item>
							<v-list-item @click="blocked">
								<v-list-item-action>
									<v-icon>cached</v-icon>
								</v-list-item-action>
								<v-list-item-title>
									{{ showBlocked ? 'Показать активных' : 'Показать заблокированных' }}
								</v-list-item-title>
							</v-list-item>
						</template>
					</v-list>
				</v-menu>
			</v-card-title>
			<a-data-table
				ref="table"
				:headers="headers"
				:items-per-page="25"
				api-path="users/get_users"
				:api-parameters="{
					showBlocked: showBlocked,
					hotels: $store.getters.userHo ? null : $store.getters.userHotels
				}"
				@click:row="clickRow"
				filter-client
				show-expand
				single-expand
			>
				<template v-slot:item.lastSeen="{ item }">
					<div class="text-no-wrap">
						{{ item.lastSeenFormatted }}
					</div>
				</template>
				<template v-slot:expanded-item="{ item }">
					<td colspan="7" class="pa-0">
				        <v-card dark tile>
				          	<v-container>
								<v-row v-if="loadingUser" class="pa-3">
									<v-progress-linear indeterminate color="white"></v-progress-linear>
								</v-row>
								<v-row v-else>
									<v-col cols="2">
							            <v-list dense>
											<v-subheader>Информация</v-subheader>
											<v-list-item>
												<v-list-item-content>Статус</v-list-item-content>
											</v-list-item>
							              	<v-list-item>
								                <v-list-item-content>Дата регистрации</v-list-item-content>
							            	</v-list-item>
							              	<v-list-item>
								                <v-list-item-content>Должность</v-list-item-content>
							            	</v-list-item>
										</v-list>
									</v-col>
									<v-col cols="4">
							            <v-list dense>
											<v-subheader></v-subheader>
											<v-list-item>
												<v-list-item-content>
													{{ item.statusText ? item.statusText : '' }}
												</v-list-item-content>
											</v-list-item>
							              	<v-list-item>
								                <v-list-item-content>
													{{ item.regDate ? item.regDate : '' }}
												</v-list-item-content>
							            	</v-list-item>
							              	<v-list-item>
								                <v-list-item-content>
													{{ item.position ? item.position : '' }}
												</v-list-item-content>
							            	</v-list-item>
										</v-list>
									</v-col>
									<v-col cols="1">
									</v-col>
									<v-col cols="5">
										<v-list dense>
											<v-subheader>Роли</v-subheader>
								          	<v-list-item
												v-for="role in (item.roleNames ? item.roleNames : ['', '', ''])"
												:key="role"
											>
									            <v-list-item-content>
									              	<v-list-item-title v-text="role"></v-list-item-title>
									            </v-list-item-content>
								          	</v-list-item>
								        </v-list>
									</v-col>
								</v-row>
							</v-container>
							<v-card-actions v-if="!loadingUser">
								<template v-if="!item.status">
									<v-btn text small></v-btn>
									<v-btn text small></v-btn>
								</template>
								<template v-else>
									<v-btn text small
										   @click="edit(item)">
										Редактировать
									</v-btn>
									<v-btn text small
										   @click="inviteAgain(item)"
										   v-if="item.status == 1">
										Повторно отправить приглашение
									</v-btn>
									<v-btn text small
										   @click="recoverPassword(item)"
										   v-if="item.status == 2">
										Сбросить пароль
									</v-btn>
									<v-btn text small
										   @click="block(item)"
										   v-if="item.status > 0">
										Заблокировать
									</v-btn>
									<v-btn text small
										   @click="activate(item)"
										   v-if="item.status == 0">
										Разблокировать
									</v-btn>
								</template>
					        </v-card-actions>
				        </v-card>
					</td>
			    </template>
			</a-data-table>
		</v-card>
		<v-dialog v-model="dialogEdit.show" max-width="800" persistent>
			<v-card>
				<v-form ref="f" v-model="dialogEdit.valid">
		          	<v-card-text>
		            	<v-container>
		              		<v-row >
		                		<v-col cols="6">
		                  			<v-text-field v-model="dialogEdit.user.name"
												  :rules="[rules.required]"
												  label="Имя">
									</v-text-field>
		                		</v-col>
		                		<v-col cols="6">
		                  			<v-text-field v-model="dialogEdit.user.surname" label="Фамилия"></v-text-field>
		                		</v-col>
		                		<v-col cols="6">
		                  			<!-- <v-select v-model="dialogEdit.user.position"
											  :items="positions"
											  label="Должность">
									</v-select> -->
									<v-text-field v-model="dialogEdit.user.position" label="Должность"></v-text-field>
		                		</v-col>
		                		<v-col cols="6">
		                  			<v-text-field v-model="dialogEdit.user.email"
												  label="Электронная почта"
												  :rules="[rules.required, rules.email]">
									</v-text-field>
		                		</v-col>
								<v-col cols="12">
		                  			<v-autocomplete
										v-model="dialogEdit.user.hotelCodes"
										multiple chips deletable-chips
										:rules="[rules.required]"
										:items="hotels"
										item-value="code"
										item-text="name"
										label="Отели"
									></v-autocomplete>
		                		</v-col>
								<v-col cols="12">
		                  			<v-autocomplete
										v-model="dialogEdit.user.roleCodes"
										multiple chips deletable-chips
										:rules="[rules.required]"
										:items="roles"
										item-value="code"
										item-text="name"
										label="Роли"
									></v-autocomplete>
		                		</v-col>
		              		</v-row>
		            	</v-container>
		          	</v-card-text>
				</v-form>

		        <v-card-actions>
					<v-btn
						text
					   @click="add"
					   :disabled="!dialogEdit.valid"
					   :loading="dialogEdit.loading"
					   v-if="dialogEdit.new"
					>
						Добавить
					</v-btn>
					<v-btn
						text
					   @click="save"
					   :disabled="!dialogEdit.valid"
					   :loading="dialogEdit.loading"
					   v-else
					>
						Сохранить
					</v-btn>
		            <v-btn text @click="close">Отмена</v-btn>
		        </v-card-actions>
        	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
	tr.scroll-loading,
	tr.scroll-loading td {
		height: auto;
		border: none;
	}
</style>

<script>
	import aDataTable from '../base/ADataTable.vue'
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
			aDataTable
		},
		data: () => ({
			loadingList: false,
			loadingUser: false,
			showBlocked: false,
			listsLoaded: false,
			dialogEdit: {
				show: false,
				valid: false,
				new: false,
				loading: false,
				user: {
					id: 0,
					name: '',
					surname: '',
					position: '',
					email: '',
					hotelCodes: [],
					roleCodes: [],
				}
			},
			headers: [
				{
					text: 'id',
					value: 'id',
					align: 'center',
					sortable: true,
					filterable: false,
				},
				{
					text: 'Имя',
					value: 'fullName',
					align: 'center',
					sortable: true,
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Электронная почта',
					value: 'email',
					align: 'center',
					sortable: true,
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Отели',
					value: 'hotelsString',
					align: 'center',
					sortable: true,
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Роли',
					value: 'rolesCount',
					align: 'center',
					sortable: true,
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Последние действия',
					value: 'lastSeen',
					align: 'center',
					sortable: true,
					filterable: true,
					filterType: 'dateTime',
				}
			],
			rules: {
	          	required: value => !!value.length || 'Обязательно',
	          	email: value => {
		            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		            return pattern.test(value) || 'Некорректный адрес электронной почты'
		        }
	        },
			// positions: [],
			roles: null,
			// forceLoad: false,
		}),
		computed: {
			hotels() {
				let htls = _.cloneDeep(this.$store.getters.availableHotels)
				if (this.$store.getters.userHo) htls.unshift('HO')
				return htls
			}
		},
		methods: {
			clickRow (row) {
				this.loadingUser = true

				api.post('users/get_user_info', {
					id: row.id
				})
				.then(response => {

					for (let prop in response.data.user) {
						this.$set(row, prop, response.data.user[prop])
					}

					this.loadingUser = false

					this.getLists()

				}, error => {})
			},
			newUser() {
				this.getLists()
				this.dialogEdit.new = true
				this.dialogEdit.user = {
					id: 0,
					name: '',
					surname: '',
					position: '',
					email: '',
					hotelCodes: [],
					roleCodes: [],
				}
				this.dialogEdit.show = true
				if (this.$refs.f != undefined) this.$refs.f.resetValidation()
			},
			inviteAgain(user) {
				api.post('users/invite_again', {
					id: user.id
				})
				.then(response => {

					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: 'Приглашение повторно отправлено пользователю'
					})

				}, error => {})
			},
			block(user) {
				api.post('users/block_user', {
					id: user.id
				})
				.then(response => {

					// this.forceLoad = true
					this.$refs.table.clearAndLoad()

					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: 'Пользователь заблокирован'
					})

				}, error => {})
			},
			activate(user) {
				api.post('users/activate_user', {
					id: user.id
				})
				.then(response => {

					// this.forceLoad = true
					this.$refs.table.clearAndLoad()

					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: 'Пользователь разблокирован'
					})

				}, error => {})
			},
			add() {
				// this.$refs.f.validate()

				if (!this.dialogEdit.valid) return

				this.dialogEdit.loading = true

				let user = this.dialogEdit.user

				api.post('users/add_user', {
					name: user.name,
					surname: user.surname,
					position: user.position,
					email: user.email,
					hotelCodes: user.hotelCodes,
					roleCodes: user.roleCodes
				})
				.then(response => {

					// this.forceLoad = true
					this.$refs.table.clearAndLoad()

					this.dialogEdit.show = false
					this.dialogEdit.loading = false

				}, error => {})
			},
			save() {
				// this.$refs.f.validate()

				if (!this.dialogEdit.valid) return

				this.dialogEdit.loading = true

				let user = this.dialogEdit.user

				api.post('users/set_user_info', {
					id: user.id,
					name: user.name,
					surname: user.surname,
					position: user.position,
					email: user.email,
					hotelCodes: user.hotelCodes,
					roleCodes: user.roleCodes
				})
				.then(response => {

					this.$refs.table.clearAndLoad()

					this.dialogEdit.show = false
					this.dialogEdit.loading = false

				}, error => {})
			},
			close() {
				this.dialogEdit.show = false
			},
			edit(user) {
				this.getLists()

				this.dialogEdit.new = false
				this.dialogEdit.user = Object.assign({}, user)
				this.dialogEdit.user.hotelCodes = user.hotelsString.split(', ')
				this.dialogEdit.user.roleCodes = user.roleCodes

				this.dialogEdit.show = true
			},
			recoverPassword(user) {
				api.post('users/recover_password', {
					id: user.id
				})
				.then(response => {

					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: 'Новый пароль отпрален пользователю на email'
					})

				}, error => {})
			},
			blocked() {
				this.showBlocked = 1 - this.showBlocked
			},
			getLists() {
				if (!this.listsLoaded) {
					api.post('users/get_all_roles', { hotel: !this.$store.getters.userHo })
					.then(response => {

						this.roles = response.data.data

						this.listsLoaded = true

					}, error => {})
				}
			},
		}
	}
</script>
